module.exports = __webpack_public_path__ + "static/media/Icons_menu-down-arrow.34e15ff7.svg";